import { Component, OnInit } from '@angular/core';
import { TransferService } from '../../../_provider/transfer.service';
import { NavController, Platform, PopoverController } from '@ionic/angular';
import { PopoverPage } from '../../popover/popover.page';
import { Subscription } from 'rxjs';
import { DarkmodeService } from '../../../_provider/darkmode.service';
import { EditArt } from '../../../_interfaces/EditArt';
import { TicketEmployee } from '../../../_provider/tickets/ticket.service';
import { SaveService } from '../../../_provider/save.service';
import { KundenPopoverPage } from '../../popover/kunden-popover/kunden-popover.page';
import { AddressBase } from '../../../_interfaces/address';
import { AnsprechpartnerPopoverPage } from '../../popover/ansprechpartner-popover/ansprechpartner-popover.page';
import { ContactPerson } from '../../../_interfaces/ContactPerson';
import { TicketArtSelectPage } from './ticket-art-select/ticket-art-select.page';
import { TicketEditService } from 'src/app/_provider/ticket-edit.service';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { CrmDetailPagePage } from 'src/app/_pages/crm-detail-page/crm-detail-page.page';
import { GeneralService } from 'src/app/_provider/general.service';
import { TicketDetailWorkersComponent } from '../ticket-detail-workers/ticket-detail-workers.component';
import { ImpactStyle } from '@capacitor/haptics';

@Component({
    selector: 'app-ticket-detail-allgemein',
    templateUrl: './ticket-detail-allgemein.component.html',
    styleUrls: ['./ticket-detail-allgemein.component.scss'],
    standalone: false
})
export class TicketDetailAllgemeinComponent implements OnInit {

  public ticketArt: EditArt = {id: 1, description: "Anderes"}
  public berechnen: EditArt = {id: 1, description: "Nicht Berechnen"}
  public kontaktart: EditArt = {id: 1, description: "Telefon"}
  public prio: EditArt = {id: 1, description: "Wichtig"} 

  private darkmodeSub: Subscription

  public isDarkmode: boolean

  constructor(
    private transfer: TransferService,
    private popoverController: PopoverController,
    public ticketSrv: TicketEmployee.TicketService,
    public saveSrv: SaveService.Ticket,
    private feedback: FeedbackService,
    public  generalSrv: GeneralService,
    public darkmode: DarkmodeService,
    private ticketEditSrv: TicketEditService,
    private navCtrl: NavController,
    public platform: Platform
  ) {
    this.darkmodeSub = darkmode.isDarkMode.subscribe((result: boolean)=>{
      this.isDarkmode = result
    })
  }

  ngOnInit() {
  }

  async showArt(ev: any){

    await this.feedback.openModal<EditArt>(TicketArtSelectPage, null, (result: HttpFunctionResult<EditArt>)=>{
      if(!result.success) return

      this.ticketSrv.ticketArt = result.data
      this.saveSrv.saveTicketArt(result.data)
      
      //Zu Berechnen setzen
      if(result.data.toCalculate < 0) return 
      const toCalculate: EditArt = this.ticketEditSrv.toCalculateList.find(tc => tc.id == result.data.toCalculate)
      if(!toCalculate) return
      this.ticketSrv.berechnen = toCalculate
      this.saveSrv.saveToCalculate(toCalculate)

    })
  }

  async showBerechnen(ev: any){
    const result: EditArt = await this.showPopover(ev, "Calculate")
    if (!result) return 
    this.ticketSrv.berechnen = result
    this.saveSrv.saveToCalculate(result)
  }

  async showKontaktart(ev: any){
    const result: EditArt = await this.showPopover(ev, "Contact")
    if (!result) return
    this.ticketSrv.kontaktArt = result
    this.saveSrv.saveContactArt(result)
  }

  async showPrio(ev: any){
    const result: EditArt = await this.showPopover(ev, "Priority")
      if (!result) return
      this.ticketSrv.prioriry = result
      this.saveSrv.savePriority(result)
  }

  public async saveOnlineRelease(){
    if(!this.generalSrv?.webConfig?.hasCustomerLogin) return
      if((await this.feedback.confirm(
        this.ticketSrv.ticket.onlineRelease ?
        `Möchten Sie die Freigabe für das Ticket "${this.ticketSrv.ticket.description}" wirklich entfernen?`:
        `Möchten Sie das Ticket "${this.ticketSrv.ticket.description}" wirklich für Kunden freigeben?`, 

        this.ticketSrv.ticket.onlineRelease ? "Freigabe entfernen" : "Freigeben",
        "Abbrechen"
      ))){

        //Abfragen ob Ansprechpartner mail geschickt werden soll dass Ticket freigegeben wurde
        let sendMail: boolean = false
        if(!this.ticketSrv.ticket.onlineRelease && this.ticketSrv?.contactPerson && !!this.ticketSrv?.contactPerson?.email)
          sendMail = await this.feedback.confirm(`Soll ${this.ticketSrv?.contactPerson?.firstName} ${this.ticketSrv?.contactPerson?.lastName} eine Freigabebestätigung per E-Mail gesendet werden?`, "E-Mail senden", "Nicht senden")
        
        this.ticketSrv.ticket.onlineRelease = !this.ticketSrv.ticket.onlineRelease
        const result: HttpFunctionResult<any> = await this.saveSrv.saveOnlineRelease(sendMail, this.ticketSrv?.contactPerson?.id || 0)
        if(!result.success) this.ticketSrv.ticket.onlineRelease = !this.ticketSrv.ticket.onlineRelease
      }
  }

  
  public async rangeEnd(){
    setTimeout(() => {
      if(!this.ticketSrv.process) return
      this.saveSrv.saveProcess(this.ticketSrv.process)
    }, 200);
  }

  showPopover(ev: any, type: "TicketArt" | "Calculate" | "Contact" | "Priority" ): Promise<EditArt>{
    return new Promise(async resolve=>{
      this.transfer.clearPopover()
      const popover = await this.popoverController.create({
        component: PopoverPage,
        event: ev,
        translucent: true,
        mode: "md",
        componentProps: {type: type}
      });
      popover.onWillDismiss().then(()=>{
        let item: EditArt = this.transfer.getPopoverSelectedItem()
        this.transfer.clearPopover()
        if(item){
          resolve(item)
        }
        resolve(null)
      })
      this.feedback.vibrate(ImpactStyle.Heavy)
      return await popover.present()
    })

  }

  public changeRange(event){
    this.ticketSrv.process = event.detail.value
  }

  public async setAddress(ev: any){
    this.feedback.openModal(KundenPopoverPage, { type: "modal" }, async ()=>{
      const address: AddressBase = this.transfer.getVALUE() as AddressBase
      if(address) await this.saveNewAddress(address)
    })
  }

  public async setContactPerson(ev: any){
    this.feedback.openModal(AnsprechpartnerPopoverPage, 
      {addressId: this.ticketSrv.ticket.address.managerId, type: "modal"}, 
      async ()=>{
        let value: ContactPerson = this.transfer.getVALUE()
        await this.saveNewContactPerson(value)
      })
  }

  private async saveNewAddress(address: AddressBase){
    this.ticketSrv.ticket.addressSearchText = address.description
    this.ticketSrv.ticket.address = address
    this.ticketSrv.contactPerson = null
    await this.saveSrv.saveAddress(address)
    this.transfer.setVALUE(null)
  }

  public async saveNewContactPerson(contactPerson: ContactPerson){
    if(!contactPerson) return
    this.ticketSrv.contactPerson = contactPerson
    await this.saveSrv.saveContactPerson(contactPerson.managerId)
    this.transfer.setVALUE(null)
  }

  public async openAddress(){
    this.generalSrv.setActiveCrm(this.ticketSrv.ticket.address)
    await this.feedback.openModal<any>(CrmDetailPagePage, {isModal: true})
  }

  public async navigateToAttachments(){
    await this.navCtrl.navigateForward("tabs/home/ticket-detail-page/attachments")
  }

  public async addEmployee(){
    await this.feedback.openModal(TicketDetailWorkersComponent)
  }

  public async navigateToAppointments(){
    await this.navCtrl.navigateForward('tabs/calendar-mobile') 
    // this.ticketSrv.appointment.timeAsIsoString =  moment(this.ticketSrv.appointment.time).toISOString()

    // await this.feedback.openModal(AppointmentPagePage, {
    //   appointment: this.ticketSrv.appointment,
    //   workstepId: this.ticketSrv.activeWorkstepId,
    //   ticketDesc: this.ticketSrv.ticket.description,
    //   isModal: true
    // })
  }

  public copyOnlineLink(){
    if(!this.ticketSrv.ticket?.onlineRelease) return this.feedback.showError("Das Ticket muss erst für den Kunden freigegeben werden, bevor der Link kopiert werden kann.")
    this.ticketSrv.copyOnlineReleaseLinkToClipboard()
    this.feedback.showInformationToast("Link zum Online-Zugang wurde in die Zwischenablage kopiert")
  }
}
